// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2B0BS","imageUploader":"EGiftCard_imageUploader__227-z"};